import React from "react";
import {
  HiXCircle,
  // HiOutlineSun,
  // HiOutlineTrash,
  // HiOutlineArrowsExpand,
  // HiLightBulb,
  BiPaste,
  // HiOutlineX,
} from "react-icons/bi";
import { useTranslation } from "react-i18next";

export default function PasteButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("Paste Selection")}
      >
        <span className="icon is-small has-text-light">
          <BiPaste className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
